import React from "react";

/** Conținut doar pentru citit: toate câmpurile și butoanele dinăuntru sunt blocate (fieldset disabled + fără clicuri).
 *  Folosit la „Vizualizează”, ca cine poate edita să deschidă o fișă fără risc să schimbe sau să șteargă ceva din greșeală. */
export default function ViewOnly({ on, children }) {
  if (!on) return <>{children}</>;
  return (
    <fieldset disabled className="view-only" data-testid="view-only">
      <div className="view-only-note">Vizualizare — datele nu se pot modifica din această fereastră.</div>
      {children}
    </fieldset>
  );
}
